export default () => ({
  id: null,
  email: null,
  campaign_source: null,
  campaign_name: null,
  campaign_medium: null,
  campaign_content: null,
  campaign_term: null,
  campaign_admin_source: null,
  sendgrid_stage: null,
  existing_user: null,
  gclid: null
})
